// bao migrate skip commit 42afd27e
import * as $ from "jquery";
import * as ko from "knockout";
import * as moment from "moment";
import templateStorage from "../../core/knockout-extensions/template-storage";
import BaoUtils from "./bao-utils";
import guid from "../factories/guid";
// bao migrate - module not found: import "services/deferred-extender";

const BaoAjax = {
	post: function (...params: any[]): JQueryXHR {
		arguments[0] = this.AbsolutePath + arguments[0];
		return $.post.apply(this, arguments);
	},
	get: function (...params: any[]): JQueryXHR {
		arguments[0] = this.AbsolutePath + arguments[0];
		return $.get.apply(this, arguments);
	},
	postSync: function (ajaxSetting: JQuery.UrlAjaxSettings): JQueryXHR {

		arguments[0].url = this.AbsolutePath + arguments[0].url;
		arguments[0].async = false;
		return $.post.apply(this, arguments);
	},
	AbsolutePath: ""
};

export class BaoSession {

	public Language: {
		Symbol: KnockoutObservable<string>,
		LanguageIndex: KnockoutObservable<number>
	} = {} as any;

	public UserSelectedTheme = ko.observable("");
	public AvailableLanguages = ko.observableArray([]);

	public User = {
		UserId: ko.observable(),
		Username: ko.observable(),
		Firstname: ko.observable(),
		Lastname: ko.observable(),
		FullName: ko.observable(),
		Email: ko.observable()
	};

	public Application = {
		ApplicationName: ko.observable(""),
		ApplicationId: ko.observable("")
	};
	public ApplicationName = ko.computed(() => {
		return this.Application.ApplicationName();
	});

	public Mandator = {
		Fullname: ko.observable("")
	};

	private _messages: any = {};
	private _permissions: any = {};
	private MessageQueue = ko.observableArray([]);
	private MessageQueueLoader = ko.computed(() => {
		if (this.MessageQueue() != null && this.MessageQueue().length > 0) {
			BaoAjax.post("Bao/GetMessages", JSON.stringify({ msgKeys: this.MessageQueue() }), (value) => {
				if (value != null && Object.prototype.toString.call(value) === "[object Array]") {
					for (let i = 0; i < value.length; i++) {
						const mobs = this._messages[value[i].Key];
						if (mobs != null && ko.isObservable(mobs)) {
							this._messages[value[i].Key](value[i].Value);
						}
					}
				}
			});
			this.MessageQueue([]);
		}
	}).extend({ throttle: 10 });

	private _InitDeferred: JQueryPromise<any> = null;

	public GetMessageBySymbol = (msgKey, languageSymbol): KnockoutObservable<string> => {
		const obs = ko.observable<string>().extend({ $deferred: $.Deferred() });
		BaoAjax.post("Bao/GetMessageBySymbol", JSON.stringify({ msgKey: msgKey, languageSymbol: languageSymbol }), obs);
		return obs;
	}

	public GetCaptions = (formName, languageSymbol) => {
		const def = $.Deferred();
		BaoAjax.post("Bao/GetCaptions", JSON.stringify({ formName: formName, languageSymbol: languageSymbol }), (result) => {
			const returnValue = {};
			if (result != null && result.length != undefined) {
				ko.utils.arrayForEach(result, (item: any) => {
					returnValue[item.ControlName] = item.Caption;
				});
			}
			def.resolve(returnValue);
		});
		return def.promise();
	}

	public GetMessage = (msgKey: string | string[], msgObservable?: KnockoutObservable<string> | KnockoutObservableArray<string>): KnockoutObservable<string> => {
		let observable;
		if (ko.isObservable(msgObservable)) {
			observable = msgObservable;
		} else {
			observable = ko.observable("");
		}
		if (observable.$deferred === undefined) {
			observable.extend({ $deferred: $.Deferred() });
		}
		let returnValue = {};
		const messagesToLoad = [];
		if (typeof msgKey === "string") {
			if (this._messages[msgKey] == undefined || (ko.isObservable(this._messages[msgKey]) && this._messages[msgKey]() == null)) {
				this._messages[msgKey] = observable;
				messagesToLoad[messagesToLoad.length] = msgKey;
			}
			returnValue = this._messages[msgKey];
		} else if (Object.prototype.toString.call(msgKey) === "[object Array]") {
			for (let i = 0; i < msgKey.length; i++) {
				if (this._messages[msgKey[i]] == undefined || (ko.isObservable(this._messages[msgKey[i]]) && this._messages[msgKey[i]]() == null)) {
					this._messages[msgKey[i]] = ko.observable("");
					messagesToLoad[messagesToLoad.length] = msgKey[i];
				}
				returnValue[msgKey[i]] = this._messages[msgKey[i]];
			}
		}
		if (messagesToLoad.length > 0) {
			ko.utils.arrayForEach(messagesToLoad, (m) => {
				this.MessageQueue.push(m);
			});
		}
		return returnValue as KnockoutObservable<string>;
	}

	public RenewSession(url?: string): JQueryPromise<boolean> {
		if (url == undefined) {
			url = "Bao/RenewSession";
		}
		return BaoAjax.post(url, (value) => {
			return value;
		}) as any;
	}

	public GetApplicationName = () => {
		const def = $.Deferred();
		if (this.Application.ApplicationName() == "") {
			const sub = this.Application.ApplicationName.subscribe(() => {
				sub.dispose();
				def.resolve(this.Application.ApplicationName());
			});
		} else {
			def.resolve(this.Application.ApplicationName());
		}
		return def.promise();
	}


	public HasPermission = (permissionKey, applicationId) => {
		const returnValue = ko.observable(false);
		let permissionFound = false;
		if (typeof permissionKey === "string") {
			if (this._permissions[permissionKey] != undefined) {
				permissionFound = true;
			}
		}
		if (permissionFound) {
			return this._permissions[permissionKey];
		} else {
			this._permissions[permissionKey] = returnValue;
			BaoAjax.post("Bao/HasPermission", JSON.stringify({ key: permissionKey, applicationId: applicationId }), (value) => {
				if (value != null) {
					returnValue(value);
				}
			});
		}
		return returnValue;
	}

	public Init = () => {
		this._InitDeferred = $.when(BaoAjax.postSync({ url: "Bao/InitSession", async: false }).done((result) => {
			ko.map.fromJS(result.User, this.User);
			ko.map.fromJS(result.Application, this.Application);
			ko.map.fromJS((result.Theme || "").toLowerCase(), this.UserSelectedTheme);
			ko.map.fromJS(result.Mandator, this.Mandator);

			let body = document.getElementsByTagName("body")[0];
			body.classList.add(this.UserSelectedTheme().trim().toLowerCase());
		}), this.initLanguage(), this.initAvailableLanguages());

		return this._InitDeferred;
	}

	private initLanguage = () => {
		let languageKey = "de";
		return BaoAjax.post("Bao/GetLanguage", (result) => {
			if (result != null) {
				this.Language = ko.map.fromJS(result);
				languageKey = result.Symbol.substring(0, 2);
			}
		}).always(() => {
			if (languageKey != "en") {
				moment.locale(languageKey);
			}
		});
	}

	private initAvailableLanguages = () => {
		return BaoAjax.post("Bao/GetAvailableLanguages", (result) => {
			if (result != null) {
				this.AvailableLanguages(result);
			}
		})
	}
}

export class BaoService {
	public Utils = BaoUtils;
	public Session = new BaoSession();
	public ErrorHandling: boolean = false;
	public AbsolutePath = window.absolutePath != null ? window.absolutePath : "/";
	public VersionedPath = window.versionedPath != null ? window.versionedPath : "/";
	public Templates = templateStorage;
	public Dialogs = [];
	public Search: any;
	private _events = [];
	private msgDefaultError = ko.observable("The connection to the server could not be established");

	constructor() {
		let self = this;

		if (!this.AbsolutePath.endsWith("/")) {
			this.AbsolutePath = this.AbsolutePath + "/";
		}
		BaoAjax.AbsolutePath = this.AbsolutePath;
		
		// default ajax settings
		$.ajaxSetup({
			type: "POST",
			contentType: "application/json; charset=utf-8",
			xhrFields: {
				withCredentials: true
			},
			beforeSend: function (xhr) {
				xhr.setRequestHeader("ClientTimeZone", self.loadClientTimeZone());
			}
		});

		// error Logging
		let _errorLoggingActive = false;
		window.onerror = function (errorMsg, url, lineNumber) {
			if (_errorLoggingActive == false) {
				_errorLoggingActive = true;
				BaoAjax.post("Application/LogJsError", JSON.stringify({ error: errorMsg, url: url, lineNumber: lineNumber }), function () {
					_errorLoggingActive = false;
				});
			}
		};

		// Error Dialog
		let errorDialogOpen = false;
		$(document).ajaxError((e, req, set) => {
			if (req.statusText == "OK" && req.status == 200 && set != null && typeof set.success == "function") {
				set.success(null, null, null);
			}
			else if (!errorDialogOpen && req.status == 404) { }
			else if (!errorDialogOpen && req.statusText != "abort" && this.ErrorHandling) {
				errorDialogOpen = true;
				const BaoDialogViewModel = window.require("Factories/baoDialog");
				const dialogModel = new BaoDialogViewModel(this.Session.ApplicationName());
				dialogModel.Width(500);
				let text = req.responseText;
				if (text.startsWith("<!DOCTYPE")) {
					text = req.statusText;
				}
				if (this.Utils.String.IsNullOrWhitespace(text)) {
					text = ko.unwrap(this.msgDefaultError);
				}

				// Display error only if there is something to display.
				if (!this.Utils.String.IsNullOrWhitespace(text)) {
					dialogModel.Template(text);
					dialogModel.Buttons([{
						Title: "Ok", Click: function () {
							dialogModel.Close();
						}, Enabled: ko.observable(true)
					}]);
					dialogModel.Open();
					dialogModel.Closed = function () {
						errorDialogOpen = false;
					};
				}

				ko.utils.arrayForEach(this.onErrorHandler(), (handler) => {
					handler();
				});
			}
		});
	}

	private onErrorHandler: KnockoutObservableArray<{ (): void; }> = ko.observableArray<{ (): void; }>([]);

	private loadClientTimeZone():string{
		let cookieName = "ClientTimeZone";
		let currentValue = this.getCookie(cookieName);

		// set default to cookie
		if (!(currentValue?.length ?? 0 > 0)) {
			currentValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
			this.setCookie(cookieName,currentValue,{path:window.location.pathname});
		}

		return currentValue;
	}

	/**
	 * Use this to get the value of a specific cookie
	 * @param name name of the cookie
	 * @returns the value of the cookie or null if cookie not exists
	 */
	public getCookie(name: string): string {
		return document.cookie
			?.split('; ')
			?.find(row => row.startsWith(name + '='))
			?.split('=')[1] ?? null;
	}
	/**
	 * Use this to set the value for a spefic cookie with options
	 * @param name name of the cookie
	 * @param value value of the cookie
	 * @param options option of the cookie see also https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
	 */
	public setCookie(name: string, value: string, options: { path?: string, domain?: string, "max-age"?: string, expires?: string, secure?: string, samesite?: string }): void {
		let cookie_val = `${name}=${value} `;
		if (options.path?.length ?? 0 > 0) {
			cookie_val += `;path=${options.path} `;
		}
		if (options.domain?.length ?? 0 > 0) {
			cookie_val += `;domain=${options.domain} `;
		}
		if (options["max-age"]?.length ?? 0 > 0) {
			cookie_val += `;max-age=${options["max-age"]} `;
		}
		if (options.expires?.length ?? 0 > 0) {
			cookie_val += `;expires=${options.expires} `;
		}
		if (options.secure?.length ?? 0 > 0) {
			cookie_val += `;secure=${options.secure} `;
		}
		if (options.samesite?.length ?? 0 > 0) {
			cookie_val += `;samesite=${options.samesite} `;
		}
		document.cookie = cookie_val;
	}

	public registerOnError(fn: () => void) {
		this.onErrorHandler.push(fn);
	}

	public unregisterOnError(fn: () => void) {
		this.onErrorHandler.remove(fn);
	}

	public init() {
		// this.Templates = window.baorequire("templates");
	}

	public initBackend() {
		this.Session.GetMessage(["msgYes", "msgNo", "msgCancel", "msgFillMandatorFields", "msgSaveCheck"]);
		this.Session.GetMessage("msgDefaultError", this.msgDefaultError);
	}

	public initSession() {
		return this.Session.Init();
	}

	public Content = (url) => {
		if (url.startsWith("/")) {
			url = url.substring(1);
		}
		return this.AbsolutePath + url;
	}
	public ContentVersioned = (url) => {
		return this.VersionedPath + url;
	}

	public post(...params): JQueryPromise<any> {

		return BaoAjax.post.apply(this, arguments);
	}

	public postSync(ajaxSetting: JQuery.UrlAjaxSettings): JQueryPromise<any> {

		return BaoAjax.postSync(ajaxSetting);
	}
	public get(...params): JQueryPromise<any> {
		return BaoAjax.get.apply(this, arguments);
	}
	public GetAjaxValue = (ajaxReturn) => {
		if (ajaxReturn != null) {
			if (Object.prototype.toString.call(ajaxReturn) === "[object Array]") {
				return ajaxReturn[0];
			} else {
				return ajaxReturn;
			}
		}
		return null;
	}

	public inherit = (child, parent) => {
		const noop = function () { };
		const ecma3 = function (ctor, superCtor) {
			noop.prototype = superCtor.prototype;
			ctor.prototype = new noop;
			ctor.prototype.constructor = superCtor;
		};
		const ecma5 = function (ctor, superCtor) {
			ctor.prototype = Object.create(superCtor.prototype, {
				constructor: { value: ctor, enumerable: false }
			});
		};
		return Object.create ? ecma5(child, parent) : ecma3(child, parent);
	}

	public raiseEvent = (topic, value?) => {
		const tempArray = this._events.slice();
		for (let i = 0; i < tempArray.length; i++) {
			if (tempArray[i].topic == topic && typeof tempArray[i].fn == "function") {
				tempArray[i].fn(value);
			}
		}
	}
	public bindEvent = (topic, fn) => {
		let found = false;
		for (let i = 0; i < this._events.length; i++) {
			if (fn == this._events[i].fn && topic == this._events[i].topic) {
				found = true;
				break;
			}
		}
		if (found == false) {
			this._events.push({ topic: topic, fn: fn });
		}
	}
	public unbindEvent = (topic, fn) => {
		for (let i = 0; i < this._events.length; i++) {
			if (fn == this._events[i].fn && topic == this._events[i].topic) {
				this._events.splice(i, 1);
			}
		}
	}

	public download = (source) => {
		if ($("body").has("#iframeDownload").length) {
			$("body > #iframeDownload").remove();
		}
		$("body").append("<iframe id=\"iframeDownload\" style=\"display:none\" src=\"" + source + "\"></iframe>");
	}
}

const m = new BaoService();
export default m;
